import React from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import { CircularIconButton } from "shared/buttons"

const UserFormBuilderList = ({ users = [], deleteCategoryAbility }) => {
  if (!users.length) {
    return <div>No Form Builder Users</div>
  }

  return (
    users.map(({ abilityId, grantee }) => (
      <ItemRow
        key={abilityId}
        itemRowHeaderContent={(
          <UserInfo user={grantee} />
        )}
        itemRowHeaderControls={(
          <CircularIconButton
            ariaLabel="revoke form builder privilege from user"
            icon="close"
            onClick={deleteCategoryAbility(abilityId)}
          />
        )}
      />
    ))
  )
}

UserFormBuilderList.propTypes = {
  users: types.arrayOf(types.object),
  deleteCategoryAbility: types.func.isRequired,
}

export default UserFormBuilderList
